module.exports = __webpack_public_path__ + "static/media/IMG_0293.7be90464.jpg";